module.exports = __webpack_public_path__ + "static/img/index1_sea.8366a1d.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/home/pc/index1_sea.png
// module id = tojE
// module chunks = 7